import React from "react";
import s from "./style.module.css";
import cn from "classnames";
import Vizualisation from "../../../../components/Vizualisation";
import ColorLegend from "../../../../components/ColorLegend/colorLegend";
import governance from "../../data/governance";
import protection from "../../data/protection";
import useVizualisation from "../../../../helpers/useVizualisation";
import { scaleOrdinal } from "d3-scale";

const Ring = ({
  id,
  name,
  established,
  inProgressOrPlanned,
  numberOfCountries,
  alt,
  inView,
  copy,
}) => {
  const getColor = (i) => {
    if (!inView) {
      return "#FBF1EE";
    }

    const first = established;
    const second = established + inProgressOrPlanned;
    if (i < first) {
      return "#EE6047";
    }
    if (i < second) {
      return "#481F7C";
    }
    return "#FBF1EE";
  };

  return (
    <div className={cn(s.ring, { [s.alt]: alt })}>
      <svg
        viewBox="0 0 183 183"
        style={{
          overflow: "visible",
        }}
      >
        {new Array(100).fill().map((_, i) => (
          <g
            key={i}
            transform={`translate(103, 0.000000) rotate(${
              i * (360 / 100) - 10
            }, -11.5, 91.5)`}
            fill={getColor(i, established, inProgressOrPlanned)}
            id="Path"
          >
            <path
              style={{
                transitionDelay: `${i * 0.05}s`,
              }}
              d="M12.6,1 C15.6,4.1 17.9,7.9 19.1,12.1 C20.3,16.2 20.4,20.7 19.6,24.9 C18.7,29.1 16.8,33.1 14,36.3 L9.8,40.9 C8.6,42.5 7.3,44.1 6.3,45.9 C4.2,49.4 2.7,53.3 1.8,57.4 C1,61.4 0.8,65.6 1.3,69.7 C2.2,78 6.1,85.7 11.9,91.8 C6,85.9 1.9,78.2 0.8,69.8 C0.2,65.7 0.3,61.4 1,57.3 C1.8,53.2 3.3,49.2 5.3,45.5 C6.3,43.6 7.6,41.9 8.8,40.2 L12.9,35.5 C15.5,32.3 17.2,28.5 18,24.6 C18.7,20.6 18.5,16.5 17.3,12.6 C16.1,8.8 13.9,5.3 11.1,2.4 L11.1,2.4 C10.7,2 10.7,1.4 11.1,1 C11.5,0.6 12.2,0.6 12.6,1 C12.6,1 12.6,1 12.6,1 Z"
            ></path>
          </g>
        ))}
      </svg>

      <div className={s.extras}>
        <div className={s.ringValues}>
          <div className={s.ringValue}>{established}%</div>
          <div className={s.ringValue}>{inProgressOrPlanned}%</div>
        </div>
        <div className={s.ringName}>
          {copy.of} {numberOfCountries} {copy[id]}
        </div>
      </div>
    </div>
  );
};

const RingChart = ({ title, source, data, note, copy }) => {
  const { ref, inView } = useVizualisation(0.1);

  const dataJSON = {
    governance,
    protection,
  };

  const rings = dataJSON[data];

  const colorScale = scaleOrdinal()
    .domain([copy.established, copy.inProgress])
    .range(["#EE6047", "#481F7C"]);

  return (
    <div className={s.wrap}>
      <Vizualisation title={title} source={source} note={note} size="fullwidth">
        <ColorLegend colorscale={colorScale} />

        <div className={s.rings} ref={ref}>
          {rings.map((ring, i) => (
            <Ring key={i} {...ring} alt={i % 2} inView={inView} copy={copy} />
          ))}
        </div>
      </Vizualisation>
    </div>
  );
};

export default RingChart;
